export default "__VITE_ASSET__DLdE1OD8__"